/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CertPinDTO,
    CertPinDTOFromJSON,
    CertPinDTOToJSON,
    InlineObject,
    InlineObjectFromJSON,
    InlineObjectToJSON,
    ServicePlatformDTO,
    ServicePlatformDTOFromJSON,
    ServicePlatformDTOToJSON,
    SystemMetadataDTO,
    SystemMetadataDTOFromJSON,
    SystemMetadataDTOToJSON,
} from '../models';

export interface DeleteRequest {
    id: string;
}

export interface CertPinInfoRequest {
    inlineObject?: InlineObject;
}

export interface DeleteServicePlatformRequest {
    id: string;
}

export interface UpsertRequest {
    systemMetadataDTO: SystemMetadataDTO;
}

export interface UpsertServicePlatformRequest {
    servicePlatformDTO: ServicePlatformDTO;
}

/**
 * 
 */
export class SystemMetadataControllerApi extends runtime.BaseAPI {

    /**
     */
    async _deleteRaw(requestParameters: DeleteRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling _delete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/ws/metadata/delete-ws-client/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async _delete(id: string, initOverrides?: RequestInit): Promise<void> {
        await this._deleteRaw({ id: id }, initOverrides);
    }

    /**
     */
    async certPinInfoRaw(requestParameters: CertPinInfoRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<CertPinDTO>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/ws/metadata/certpin`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InlineObjectToJSON(requestParameters.inlineObject),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CertPinDTOFromJSON(jsonValue));
    }

    /**
     */
    async certPinInfo(inlineObject?: InlineObject, initOverrides?: RequestInit): Promise<CertPinDTO> {
        const response = await this.certPinInfoRaw({ inlineObject: inlineObject }, initOverrides);
        return await response.value();
    }

    /**
     */
    async deleteServicePlatformRaw(requestParameters: DeleteServicePlatformRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteServicePlatform.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/ws/metadata/delete-serviceplatform-client/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteServicePlatform(id: string, initOverrides?: RequestInit): Promise<void> {
        await this.deleteServicePlatformRaw({ id: id }, initOverrides);
    }

    /**
     */
    async getAllServicePlatformsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<ServicePlatformDTO>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/ws/metadata/service-platforms`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ServicePlatformDTOFromJSON));
    }

    /**
     */
    async getAllServicePlatforms(initOverrides?: RequestInit): Promise<Array<ServicePlatformDTO>> {
        const response = await this.getAllServicePlatformsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllSystemMetadatasRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<SystemMetadataDTO>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/ws/metadata/ws-clients`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SystemMetadataDTOFromJSON));
    }

    /**
     */
    async getAllSystemMetadatas(initOverrides?: RequestInit): Promise<Array<SystemMetadataDTO>> {
        const response = await this.getAllSystemMetadatasRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async upsertRaw(requestParameters: UpsertRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<SystemMetadataDTO>> {
        if (requestParameters.systemMetadataDTO === null || requestParameters.systemMetadataDTO === undefined) {
            throw new runtime.RequiredError('systemMetadataDTO','Required parameter requestParameters.systemMetadataDTO was null or undefined when calling upsert.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/ws/metadata/save-ws-client`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SystemMetadataDTOToJSON(requestParameters.systemMetadataDTO),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SystemMetadataDTOFromJSON(jsonValue));
    }

    /**
     */
    async upsert(systemMetadataDTO: SystemMetadataDTO, initOverrides?: RequestInit): Promise<SystemMetadataDTO> {
        const response = await this.upsertRaw({ systemMetadataDTO: systemMetadataDTO }, initOverrides);
        return await response.value();
    }

    /**
     */
    async upsertServicePlatformRaw(requestParameters: UpsertServicePlatformRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ServicePlatformDTO>> {
        if (requestParameters.servicePlatformDTO === null || requestParameters.servicePlatformDTO === undefined) {
            throw new runtime.RequiredError('servicePlatformDTO','Required parameter requestParameters.servicePlatformDTO was null or undefined when calling upsertServicePlatform.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/ws/metadata/save-service-platform-client`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ServicePlatformDTOToJSON(requestParameters.servicePlatformDTO),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ServicePlatformDTOFromJSON(jsonValue));
    }

    /**
     */
    async upsertServicePlatform(servicePlatformDTO: ServicePlatformDTO, initOverrides?: RequestInit): Promise<ServicePlatformDTO> {
        const response = await this.upsertServicePlatformRaw({ servicePlatformDTO: servicePlatformDTO }, initOverrides);
        return await response.value();
    }

}
